import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Button, Table, Nav, NavItem, FormControl, Row, Col, Tooltip, OverlayTrigger, Checkbox } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Loading from "components/Loading";
import EmbedCodeModal from "components/EventPage/EmbedCode/EmbedCodeModal";
import locale from "locale";
import { updateEpisode } from '../../../../api/cp';
import { createEpisodeRecord, createStreamRecord, getRecordsList } from "../../../../api/cp/records";
import { Event } from "../../Comet";
import cloneDeep from "lodash.clonedeep";

const DownloadButtonTooltip = ({ text, children }) => {
	if (!text) return children;

	const tooltip = (
		<Tooltip id={`tooltip-download-button`}>{text}</Tooltip>
	);

	return (
		<OverlayTrigger key="download-button" placement="top" overlay={tooltip}>
			<span>{children}</span>
		</OverlayTrigger>
	);
}

const DownloadButton = ({ hasRecord, link }) => {
	if (!hasRecord) {
		return <span>Нет записи</span>
	}

	if (!link) {
		return (
			<Button disabled={true} bsSize="small" style={{ pointerEvents: 'none' }}>Скачать</Button>
		);
	}

	return (
		<Button href={link} bsSize="small" download>Скачать</Button>
	)
};

function RecordRow({ record, episode, currentStream, qualities, languages, onShowEmbed, onToggleDisplayRecord, onExport }) {
	const [quality, setQuality] = useState();
	const [language, setLanguage] = useState();

	const handleChangeQuality = (e) => {
		setQuality(qualities.find(q => parseInt(q.number) === parseInt(e.target.value)) || null);
	}
	const handleChangeLanguage = (e) => {
		setLanguage(languages.find(l => l.channel === e.target.value) || null);
	}

	const archiveStatus = episode ? episode.archiveStatus : currentStream.archiveStatus;
	const hasRecord = ['done', 'file'].indexOf(archiveStatus) >= 0;

	const isQualityEmpty = qualities.length && !quality;
	const isLanguageEmpty = languages.length && !language;
	const isFlussonic = currentStream?.liveProfile?.originType === 'flussonic';

	const exportEnabled = Boolean(record && (record.type !== 'episode' || record.archiveStatus === 'done'));

	// const link = useMemo(() => {
	// 	if (!hasRecord) return null;

	// 	if (isFlussonic) {
	// 		return currentStream.vodProfile.recordServer.webPath + '/'
	// 			+ currentStream.name
	// 			+ (episode ? '_' + episode.id : '')
	// 			+ '.mp4'
	// 			;
	// 	}

	// 	if (isQualityEmpty || isLanguageEmpty) return null;

	// 	return currentStream.vodProfile.recordServer.webPath + '/'
	// 		+ currentStream.name
	// 		+ ((quality && !isFlussonic) ? '_' + quality.number : '')
	// 		+ (language ? '_' + language.channel : '')
	// 		+ (episode ? '_' + episode.id : (currentStream.archiveStatus === 'file' ? '_0' : ''))
	// 		+ '.mp4'
	// 		;
	// }, [currentStream, episode, quality, language, hasRecord, isQualityEmpty, isLanguageEmpty, isFlussonic]);

	// const downloadButtonTooltipText = useMemo(() => {
	// 	if (isFlussonic) {
	// 		return 'Cкачиваемый файл содержит в себе стримы во всех качествах и отдельные стримы по языковым дорожкам';
	// 	}

	// 	if (isQualityEmpty || isLanguageEmpty) {
	// 		let tooltipRequires = [];
	// 		if (isQualityEmpty) tooltipRequires.push('качество');
	// 		if (isLanguageEmpty) tooltipRequires.push('язык');
	// 		return `Выберите ${tooltipRequires.join(', ')}`;
	// 	}

	// 	return null;
	// }, [isFlussonic, isQualityEmpty, isLanguageEmpty]);

	const handleCreateExport = async () => {
		if (!record) return;
		const data = { audioChannel: language?.channel, videoHeight: quality?.height };
		try {
			const _record = record.type === 'episode' ? await createEpisodeRecord(record.id, data) : await createStreamRecord(record.id, data);
			onExport(_record)
		} catch (e) {
			console.error(e)
		}
	}

	return (
		<tr>
			<td>{episode ? episode.name_ru : currentStream.description_ru}</td>
			<td>
				{
					episode &&
					<Checkbox
						checked={episode.displayRecord}
						onChange={(e) => onToggleDisplayRecord(episode, e.target.checked)}
					/>
				}
			</td>
			{!isFlussonic && qualities.length ?
				<td>
					<FormControl componentClass="select" bsSize="small" onChange={handleChangeQuality} value={quality ? quality.number : ''}>
						<option value="">Качество</option>
						{qualities.map(quality => <option key={`quality_${quality.number}`} value={quality.number}>{quality.label}</option>)}
					</FormControl>
				</td>
				: null}
			{!isFlussonic && languages.length ?
				<td>
					<FormControl componentClass="select" bsSize="small" onChange={handleChangeLanguage} value={language ? language.channel : ''}>
						<option value="">Язык</option>
						{languages.map(language => <option key={`language_${language.channel}`} value={language.channel}>{language.label}</option>)}
					</FormControl>
				</td>
				: null}
			<td>
				{exportEnabled && <Button onClick={handleCreateExport} bsSize="small">Экспорт</Button>}
				{/* <DownloadButtonTooltip text={downloadButtonTooltipText}>
					<DownloadButton hasRecord={hasRecord} link={link} />
				</DownloadButtonTooltip> */}
			</td>
			{/* {episode &&
            <td>
                <Button href={`https://${location.hostname}/watch/${episode.key}`} target="_blank" bsSize="small">Просмотр</Button>
            </td>} */}
			{episode &&
				<td>
					<Button onClick={() => onShowEmbed(episode)} bsSize="small">Код встраивания</Button>
				</td>}
		</tr>
	);
}

class PageRecords extends React.Component {
	state = {
		currentStream: null,
		qualities: [],
		languages: [],
		records: [],
		isLoading: true,
		showEmbedEpisode: null,
	};

	handleChangeStream(id) {
		const stream = (this.state.event || this.props.event).stream.find(stream => stream.id === id);

		this.setState({
			currentStream: stream,
			qualities: stream.quality.filter(i => i.enabled).sort((a, b) => a.number - b.number),
			languages: stream.language.filter(i => i.enabled)
		});
	}

	toggleDisplayAllRecording() {
		const isEveryDisplayed = this.state.currentStream.episode.every(({ displayRecord }) => displayRecord);
		Promise.all(this.state.currentStream.episode.map((episode) => this.toggleDisplayRecord(episode, !isEveryDisplayed)));
	}

	async toggleDisplayRecord(e, isDisplaing) {
		if (e.displayRecord === isDisplaing) return;

		const episode = await updateEpisode(e.id, { displayRecord: isDisplaing });
		this.handleUpdateStreamEpisodeState(episode);
	}

	handleUpdateStreamEpisodeState(episode) {
		const updatedStream = {
			...this.state.currentStream,
			episode: this.state.currentStream?.episode?.map((ep) => {
				if (ep.id === episode.id) return episode;

				return ep;
			}),
		};

		this.setState({
			currentStream: updatedStream,
			event: {
				...this.state.event,
				stream: this.state.event.stream.map((stream) => {
					if (stream.id === updatedStream.id) return updatedStream;

					return stream;
				})
			}
		});
	}

	handleCometEpisodeUpdate(episode) {
		this.handleUpdateStreamEpisodeState(episode);
	}

	handleAddExport(record) {
		if (!this.state.records.find(({ id }) => id === record.id)) {
			this.setState({ records: [...this.state.records, record] });
		}
	}

	handleUpdateExports(task) {
		const index = this.state.records.findIndex(({ records }) => records.some(({ id }) => id === task.id));
		if (index >= 0) {
			const records = cloneDeep(this.state.records);
			const { status, progress, startedAt, updatedAt } = task;
			records[index] = {
				...records[index],
				records: records[index].records.map(r => {
					if (r.id === task.id) {
						if (status !== r.status) {
							this.getRecords(this.state.event.eventPassword)
						}
						return { ...r, status, progress, startedAt, updatedAt }
					} else return r
				})
			}
			this.setState({ records });
		}
	}

	async getRecords(eventPassword) {
		const records = await getRecordsList(eventPassword);
		this.setState({ records });
	}

	componentDidMount() {
		const { event } = this.props;
		this.setState({ event });
		this.handleChangeStream(event.stream[0].id);
		this.getRecords(event.eventPassword)
	}

	render() {
		const { event, currentStream, qualities, languages, records, showEmbedEpisode, displayAllRecords } = this.state;

		if (!currentStream || !event) {
			return <Loading />;
		}

		const currentRecords = records.filter(({ streamId }) => streamId === currentStream.id);
		const exports = currentRecords.reduce((acc, cur) => {
			acc.push(...(cur.records || []).map(r => ({ ...r, title: cur.nameRu })))
			return acc
		}, [])

		return (<section className="PageRecords">
			<Event event="task:stream/record" handler={this.handleUpdateExports.bind(this)} />
			{/* <Event event="update:episode" handler={this.handleCometEpisodeUpdate.bind(this)} /> */}
			<Row>
				<Col xs={10}>
					<Breadcrumb>
						<LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>{locale('mainMenu.event')}</Breadcrumb.Item></LinkContainer>
						<Breadcrumb.Item active>{locale('mainMenu.records')}</Breadcrumb.Item>
					</Breadcrumb>
				</Col>
				<Col xs={2}>
					<Button href={`/api/cp/event/${event.eventPassword}/episode.xlsx`}>Скачать список</Button>
				</Col>
			</Row>

			<Nav bsStyle="tabs" activeKey={currentStream.id} onSelect={this.handleChangeStream.bind(this)}>
				{event.stream.map(stream => <NavItem key={stream.id} eventKey={stream.id}>{stream.description_ru}</NavItem>)}
			</Nav>
			<Table>
				<thead>
					<tr>
						<th>Название</th>
						<th width="100">
							{/* Включить отображение записи у прошедших эпизодов */}
							Показывать в виджете программы
							<Checkbox
								checked={this.state.currentStream.episode.every(({ displayRecord }) => displayRecord)}
								onChange={this.toggleDisplayAllRecording.bind(this)}
							/>
						</th>
						{qualities.length ? <th width="120">Качество</th> : null}
						{languages.length ? <th width="120">Язык</th> : null}
						<th width="120">Экспорт</th>
						{/* <th width="100">Просмотр</th> */}
						<th width="180">Код встраивания</th>
					</tr>
				</thead>
				<tbody>
					<RecordRow
						event={event}
						currentStream={currentStream}
						record={currentRecords.find(({ id }) => id === currentStream.id)}
						qualities={qualities}
						languages={languages}
						onExport={this.handleAddExport.bind(this)}
					/>
					{currentStream.episode.map(episode =>
						<RecordRow
							event={event}
							key={`episode_${episode.id}`}
							record={currentRecords.find(({ id }) => id === episode.id)}
							episode={episode}
							currentStream={currentStream}
							qualities={qualities}
							languages={languages}
							onShowEmbed={episode => this.setState({ showEmbedEpisode: episode })}
							onToggleDisplayRecord={(episode, isDisplaing) => this.toggleDisplayRecord(episode, isDisplaing)}
							onExport={this.handleAddExport.bind(this)}
						/>
					)}
				</tbody>
			</Table>

			{!!exports.length && <>
				<div style={{ width: '100%', padding: '1rem', borderBottom: '1px solid #ddd' }}><b>Записи</b></div>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
					{exports.map(exp => <div key={exp.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem' }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
							<b>{exp.title}</b>
							<span>{exp.videoSize}p</span>
							<span>{languages.find(({ channel }) => channel === exp.audioChannel)?.label}</span>
						</div>
						<div>
							{exp.status === 'done' ? (
								<Button href={exp.recordUrl}>Скачать</Button>
							) : (
								<>
									<span>
										{exp.status === 'process' ? 'Конвертируется' : exp.status === 'idle' ? 'В очереди' : 'Ошибка'}
										{exp.status === 'process' && ':'}
									</span>
									{exp.status === 'process' && exp.progress !== null && (
										<span>{parseInt(exp.progress) + '%'}</span>
									)}
								</>
							)}
						</div>
					</div>)}
				</div>
			</>}

			<EmbedCodeModal
				show={!!showEmbedEpisode}
				event={event}
				episode={showEmbedEpisode}
				onHide={() => this.setState({showEmbedEpisode: null})}
				streamOriginType={currentStream?.liveProfile?.originType}
			/>

		</section>);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PageRecords);
